import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollMemoryContext = createContext(null);

export const ScrollMemoryProvider = ({ children }) => {
  const scrollPositions = useRef({});
  const location = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    const handleScroll = () => {
      // Save current scroll position to the current pathname
      scrollPositions.current[location.pathname] = window.scrollY;
    };

    // Debounce to improve performance
    let timeout;
    const onScroll = () => {
      if (timeout) cancelAnimationFrame(timeout);
      timeout = requestAnimationFrame(handleScroll);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname]);

  useEffect(() => {
    // When route changes, check if we're navigating back (POP) or forward (PUSH/REPLACE)
    if (navType === 'POP') {
      const savedPosition = scrollPositions.current[location.pathname];
      if (savedPosition !== undefined) {
        // Restore scroll position
        window.scrollTo({ top: savedPosition, behavior: 'instant' });
      }
    } else {
      // Scroll to top on new navigations
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [location.pathname, navType]);

  return (
    <ScrollMemoryContext.Provider value={{}}>
      {children}
    </ScrollMemoryContext.Provider>
  );
};

export const useScrollMemory = () => useContext(ScrollMemoryContext);
